import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AuthPageContainer } from './styles';
import { getAuthenticationToken } from 'redux/actions/user';
import { getReversedTrimmedUserId } from 'utils/customHooks';
import { setToken, logout } from 'utils/auth';
import { useQuery} from 'utils/useQuery';


const AuthRedirect = ({ history }) => {
  const { id } = useParams();
  const query = useQuery('code');
  const path = query.get('path');

  const dispatch = useDispatch();

  useEffect(
    () => {
      const handleRedirect = async () => {
        try {
          if (!id) {
            logout();
            return;
          }

          const sk = getReversedTrimmedUserId(id);
          const response = await dispatch(getAuthenticationToken(id, sk));
          if (response?.payload?.status !== 200) {
            logout();
            return;
          } else {
            setToken(response?.payload?.data?.access);
            window.history.replaceState({}, '', '/auth-access');
            if (path && path !== '/') {
              // Optional: Clean up any accidental leading slashes in the path variable
              const cleanPath = path.startsWith('/') ? path.slice(1) : path;
              history.push(`/${cleanPath}`, { replace: true });
              return;
            }

            history.push('/home', { replace: true });
            return;
            
          }
        } catch (error) {
          window.history.replaceState({}, '', '/auth-access');
          logout();
          return;
        }
      };

      handleRedirect();
    },
    // eslint-disable-next-line
    [id, dispatch]
  );

  return (
    <AuthPageContainer fluid>
      <div className="text-center p-5">Authenticating...</div>
    </AuthPageContainer>
  );
};

export default AuthRedirect;
